import { Alignments, Modal } from '@sede-enterprise/shell-ds-react-framework';

const NcfReportingLoader = (props: { open: boolean; message?: string }) => {

  return (
    <Modal
      showFooter={false}
      closable={false}
      loading={true}
      bodyPadding={true}
      open={props.open}
      loadingBody={
        props.message !== undefined && props.message !== '' ? (
          <div>{props.message}</div>
        ) : (
          <div>Loading...</div>
        )
      }
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onClose={() => {}}
      actionsAlignment={Alignments.Center}
      data-testid='ncfReporting_loader_modal'
    ></Modal>
  );
};

export default NcfReportingLoader;
